
const Blog_Detail = () => {
    return (
        <div className="blog-details-area pt-100 pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="single-blog-details-content">
                            <div className="blog-details-img">
                                <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-1.jpg" alt="images"/>
                            </div>
                            <h2>Overcame Breeding Point Concerns Has Terminate</h2>
                            <ul>
                                <li><i className="flaticon-calendar"></i>August 30,2022</li>
                                <li><i className="flaticon-comment"></i>01 Comment</li>
                            </ul>
                            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat pretium in hac habitasse
                                platea dictumst aenean feugiat velit a vehicula pharetra.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                dictumst donec eleifend feugiat.</p>
                            <h3>A Cleansing Hot Shower or Bath</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat pretium in hac habitasse
                                platea dictumst aenean feugiat velit a vehicula pharetra.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                dictumst donec eleifend feugiat.</p>
                            <div className="row">
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="blog-details-img-2">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-2.jpg" alt="images"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="blog-details-img-2">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-3.jpg" alt="images"/>
                                    </div>
                                </div>
                            </div>
                            <h3>Conduct Replied Off Led Whether?</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat pretium in hac habitasse
                                platea dictumst aenean feugiat velit a vehicula pharetra.</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="blog-details-tags">
                                    <ul>
                                        <li>
                                            Tags:
                                        </li>
                                        <li>
                                            <a href="#">Bathroom Cleaning</a>
                                        </li>
                                        <li>
                                            <a href="#">Cleaning News</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="blog-details-tags-list">
                                    <ul>
                                        <li>
                                            Share:
                                        </li>
                                        <li>
                                            <a href="https://www.facebook.com/" target="_blank">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.youtube.com/" target="_blank">
                                                <i className="flaticon-youtube"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="one-comment">
                                <h2>One Comment</h2>
                                <div className="comment-text">
                                    <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-comment-img.jpg" alt="images"/>
                                        <h5>Kingston Damian</h5>
                                        <span>04 June 2022</span>
                                        <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibend ornare malesuada fusce se auctor nibh vitae feugiat.</p>
                                        <div className="reply-btn">
                                            <button type="submit" className="default-btn btn-style-one">
                                                Reply
                                            </button>
                                        </div>
                                </div>
                            </div>
                            <form className="leave-a-comment">
                                <h2>Leave A Comment</h2>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea className="form-control" required rows="10" placeholder="Comment"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="text" required className="form-control" placeholder="Name"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="email" required className="form-control" placeholder="Email"/>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="default-btn">Post A Comment</button>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="blog-details-right-bar">
                            <div className="recent-posts-card">
                                <h2>Recent Posts</h2>
                                <div className="recent-posts-item">
                                    <a href="blog-details.html">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-4.jpg" alt="images"/>
                                    </a>
                                    <div className="recent-text">
                                        <a href="blog-details.html">
                                            <h3>Overcame Breeding Point Concerns Has Terminate</h3>
                                        </a>
                                        <p><i className="flaticon-calendar"></i>August 30,2022</p>
                                    </div>
                                </div>
                                <div className="recent-posts-item">
                                    <a href="blog-details.html">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-5.jpg" alt="images"/>
                                    </a>
                                    <div className="recent-text">
                                        <a href="blog-details.html">
                                            <h3>8 Must-Have Products For A Clean Laundry Room</h3>
                                        </a>
                                        <p><i className="flaticon-calendar"></i>August 30,2022</p>
                                    </div>
                                </div>
                                <div className="recent-posts-item">
                                    <a href="blog-details.html">
                                        <img src="https://templates.hibotheme.com/bixu/default/assets/images/blog/blog-details-img-6.jpg" alt="images"/>
                                    </a>
                                    <div className="recent-text">
                                        <a href="blog-details.html">
                                            <h3>We Pay Attention In Every Corner Of Your Room</h3>
                                        </a>
                                        <p><i className="flaticon-calendar"></i>August 30,2022</p>
                                    </div>
                                </div>
                            </div>
                            <div className="popular-tags">
                                <h2>Popular Tags</h2>
                                <ul>
                                    <li>
                                        <a href="#">Bathroom Cleaning</a>
                                    </li>
                                    <li>
                                        <a href="#">Cleaning News</a>
                                    </li>
                                    <li>
                                        <a href="#">Commercial Cleaning</a>
                                    </li>
                                    <li>
                                        <a href="#">House Cleaning</a>
                                    </li>
                                    <li>
                                        <a href="#">Indoor Cleaning</a>
                                    </li>
                                    <li>
                                        <a href="#">Car Wash</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Blog_Detail